import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { Suspense, lazy } from 'preact/compat';
const InputGroup = lazy(
    () => import(/* webpackChunkName: "input-group" */ '../../../shared/form/input-group')
);
import { smoothScrollToElement } from '../../../shared/scroll';
import { MediaQuery as MQ } from '../../../shared/media-query';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.shown = this.getShown(props.route);

        this.state = {
            person_1_birth_time: {
                value: null,
                error: null,
                submitting: false,
            },
            person_2_birth_time: {
                value: null,
                error: null,
                submitting: false,
            },
        };
    }

    componentDidMount() {
        if (this.props.route.match(/summary/)) {
            smoothScrollToElement(document.querySelector(`#${this.props.route}`));
        }
    }

    shouldComponentUpdate(nextProps) {
        this.shown = this.getShown(nextProps.route);
    }

    componentDidUpdate() {
        if (this.props.route.match(/summary/)) {
            smoothScrollToElement(document.querySelector(`#${this.props.route}`));
        }
    }

    /* eslint-disable max-len */
    render({ report, renderBirthDate, renderBirthTime, renderBirthLocation }) {
        if (report) {
            return (
                <ascom-landing id='summary' className={this.shown ? 'is-shown' : null}>
                    <row className='has-margin-20-desktop has-margin-20-tablet has-margin-15-mobile' id='summary-overview'>
                        <column className='is-12'>
                            <h1 className='fancy-title has-padding-5-left-mobile'>
                                {report.product.display.name}
                            </h1>
                            <p className='has-padding-5-left-mobile'>
                                {report.product.display.sections[0].block[0].content[0].body}
                            </p>
                        </column>
                    </row>
                    <row
                        className='has-margin-20-desktop has-margin-20-tablet has-margin-15-mobile'
                        id='summary-your-birth-charts'
                    >
                        <column className='is-12'>
                            <h1 className='fancy-title has-padding-5-left-mobile'>
                                Your Birth Charts
                            </h1>
                            <p className='has-padding-5-left-mobile'>
                                Your compatibility reading compares the exact planetary positions between your
                                Astrology chart and your partner's. Below you'll find a description of each of your
                                individual charts.
                            </p>
                        </column>
                    </row>
                    <row
                        className='is-wrap has-margin-20-desktop has-margin-20-tablet has-margin-15-mobile'
                        id='summary-person-1'
                    >
                        <column className='is-6 is-12-mobile has-padding-5-right-desktop has-padding-5-right-tablet has-padding-25-bottom-mobile'>
                            <h1 className='fancy-title'>
                                {this.renderName(report.product.inputs.person_1_name.first)} Astrology
                            </h1>
                            <p className='has-margin-0'>
                                {renderBirthDate(report.product.inputs.person_1_birth_date)}
                            </p>
                            <p className='has-margin-0'>
                                {renderBirthTime(report.product.inputs.person_1_birth_time, 'Summary', 1)}
                            </p>
                            <p className='has-margin-0'>
                                {renderBirthLocation(report.product.inputs.person_1_birth_location)}
                            </p>
                            {this.renderBirthTimeUpdate(1)}
                        </column>
                        <column className='is-6 is-12-mobile'>
                            <div dangerouslySetInnerHTML={{ __html: report.product.birth_chart.planet_table }} />
                        </column>
                    </row>
                    <row
                        className='is-wrap has-margin-20-desktop has-margin-20-tablet has-margin-15-mobile'
                        id='summary-person-2'
                    >
                        <column className='is-6 is-12-mobile has-padding-5-right-desktop has-padding-5-right-tablet has-padding-25-bottom-mobile'>
                            <h1 className='fancy-title'>
                                {this.renderName(report.product.inputs.person_2_name.first)} Astrology
                            </h1>
                            <p className='has-margin-0'>
                                {renderBirthDate(report.product.inputs.person_2_birth_date)}
                            </p>
                            <p className='has-margin-0'>
                                {renderBirthTime(report.product.inputs.person_2_birth_time, 'Summary', 2)}
                            </p>
                            <p className='has-margin-0'>
                                {renderBirthLocation(report.product.inputs.person_2_birth_location)}
                            </p>
                            {this.renderBirthTimeUpdate(2)}
                        </column>
                        <column className='is-6 is-12-mobile'>
                            <div dangerouslySetInnerHTML={{ __html: report.product.birth_chart.planet_table_2 }} />
                        </column>
                    </row>
                </ascom-landing>
            );
        }

        return null;
    }
    /* eslint-enable max-len */

    renderName = (name) => {
        name = !MQ.isMobile() ? name.match(/.{1,18}/g).join('- ') : name;
        name = name.toLowerCase().endsWith('s') ? `${name}'` : `${name}'s`;

        return name;
    }

    renderBirthTimeUpdate = (which) => {
        if (
            !this.props.report.product.inputs[`person_${which}_birth_time`]
            &&
            this.props.logged_in
            &&
            this.props.user.member_uuid == this.props.report.member_uuid
        ) {
            return (
                <row className='is-wrap is-hidden-print has-margin-25-top-desktop has-margin-25-top-tablet'>
                    <column className='is-6 has-padding-10-right-mobile'>
                        <Suspense fallback={<div className='skeleton' />}>
                            <InputGroup
                                type='time'
                                name='birth_time'
                                label='Enter Your Birth Time:'
                                placeholder='SELECT TIME'
                                value={this.state[`person_${which}_birth_time`].value}
                                error={this.state[`person_${which}_birth_time`].error}
                                onInput={(e) => this.setBirthTime(e, which)}
                            />
                        </Suspense>
                    </column>
                    <column className='is-12 is-6-mobile has-padding-25-top-mobile'>
                        <button className='button-pink' onClick={(e) => this.addBirthTime(e, which)}>
                            {this.state[`person_${which}_birth_time`].submitting ? 'SUBMITTING...' : 'UPDATE MY REPORT'}
                        </button>
                    </column>
                </row>
            );
        }

        return null;
    }

    setBirthTime = (e, which) => {
        const state = this.state;
        state[`person_${which}_birth_time`] = {
            value: e.target.value,
            error: null,
        };

        this.setState(state);
    }

    /* eslint-disable max-len */
    addBirthTime = (e, which) => {
        if (!this.state[`person_${which}_birth_time`].value) {
            this.setState({
                birth_time: {
                    value: null,
                    error: 'Please enter your Birth Time',
                },
            });
        } else if (!this.state[`person_${which}_birth_time`].value.match(/^(?:(?:0?[0-9]|1[0-2]):[0-5][0-9] [aApP][mM]|(?:[01][0-9]|2[0-3]):[0-5][0-9])$/)) {
            this.setState({
                birth_time: {
                    value: this.state.birth_time.value,
                    error: 'Invalid Birth Time - HH:MM AM/PM',
                },
            });
        } else {
            this.props.trackEvent([
                'Site Interaction',
                'Click',
                'Update-Report-Button',
                'Readings_astrology-compatibility-redux:EnterBirthTime',
            ]);

            const state = this.state;
            state[`person_${which}_birth_time`].submitting = true;
            this.setState(state);

            this.props.addBirthTime({
                product_slug: this.props.report.constants.product_slug,
                [`person_${which}_birth_time`]: this.state[`person_${which}_birth_time`].value,
            });
        }
    }
    /* eslint-enable max-len */

    getShown = (route) => {
        return !route || (!route.match(/^your-report/) && !route.match(/^glossary/));
    }
}

const mapStateToProps = (state) => ({
    report: state.report,
    route: state.route,
    submitting: state.product && state.product.submitting,
    logged_in: state.user && state.user.logged_in,
    user: state.user,
    is_sample: state.report && state.report.product_code
        && state.report.product_code == 'astrology-compatibility-sample',
    has_birth_time: state.report && state.report.product && state.report.product.restrictions
        && state.report.product.restrictions[0] && state.report.product.restrictions[0] == 'has_birth_time',
});

const mapDispatchToProps = (dispatch) => ({
    addBirthTime: (payload) => dispatch({ type: 'report:add-birth-time', payload: payload }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
